import type { Locale } from "../../i18n/dictionary";
import { BUILT_GAMES } from "../../progress/skillRegistry.generated";
import { localized } from "../../progress/registry";

/** A game's own name from the registry; an unknown id falls back to a readable form of it. */
export function gameName(gameId: string, locale: Locale): string {
  const g = BUILT_GAMES.find((x) => x.id === gameId);
  if (g) return localized(g.name, locale);
  const dashIdx = gameId.indexOf("-");
  if (dashIdx === -1) return gameId.charAt(0).toUpperCase() + gameId.slice(1);
  const family = gameId.slice(0, dashIdx);
  const desc = gameId.slice(dashIdx + 1).replace(/-/g, " ");
  return family.charAt(0).toUpperCase() + family.slice(1) + " · " + desc;
}
